import React from 'react';
import TechnologyHero from './components/TechnologyHero';
import TechnologyServices from './components/TechnologyServices';
import CrossPlatformSection from './components/CrossPlatformSection';
import QualityStandardsSection from './components/QualityStandardsSection';
import ContactFormWidget from '../../components/ContactFormWidget';
import Footer from '../../components/Footer';

const Technologies = () => {
  return (
    <div className="technologies-page">
      <TechnologyHero />
      <TechnologyServices />
      <CrossPlatformSection />
      <QualityStandardsSection />
      <ContactFormWidget />
      <Footer />
      {/* Additional technology sections will be added here */}
    </div>
  );
};

export default Technologies; 